export const RESERVATION_STATUS_PAID = 'PAID';
export const RESERVATION_STATUS_PAIDDEPOSIT = 'PAIDDEPOSIT';
export const RESERVATION_STATUS_NOTPAID = 'NOTPAID';
export const RESERVATION_STATUS_CANCELLED = 'CANCELLED';
export const RESERVATION_STATUS_BLOCKED = 'BLOCKED';

export const getReservationStatusIconStyle = status => {
    switch (status) {
        case RESERVATION_STATUS_PAID:
            return { background: '#090', variant: 'success', };
        case RESERVATION_STATUS_PAIDDEPOSIT:
            return {
                background:
                    'linear-gradient(to bottom, transparent 0%, transparent 50%, #fa0 50%, #fa0 100%)',
                border: '2px solid #fa0',
                variant: 'warning',
            };
        case RESERVATION_STATUS_NOTPAID:
            return { border: '2px solid #c00', variant: 'danger', };
        case RESERVATION_STATUS_CANCELLED:
            return { background: '#9e9e9e', variant: 'secondary', };
        case RESERVATION_STATUS_BLOCKED:
            return { background: '#000', variant: 'black', };
        default:
            return { background: '#000', variant: 'black', };
    }
};

export const getReservationStatusTitle = status => {
    switch (status) {
        case RESERVATION_STATUS_PAID:
            return 'Paid-in-full';
        case RESERVATION_STATUS_PAIDDEPOSIT:
            return 'Confirmed';
        case RESERVATION_STATUS_NOTPAID:
            return 'Unconfirmed';
        case RESERVATION_STATUS_CANCELLED:
            return 'Canceled';
        case RESERVATION_STATUS_BLOCKED:
            return 'Blocked';
        default:
            return '';
    }
};
